<template>
	<div id="packs-page">

		<section class="container oversized-container my-2 content-section">
			<div class="row">
				<div class="col-12 col-title-s1">
					<h3 class="title">Paquete MiFi</h3>

					<open-pay-charge ref="openPayModal" />

					<p>
						Selecciona alguno de nuestros paquetes BlackFon para tu modem MiFi.
					</p>

				</div>

				<offers-slider class="col-12 col-carousel"  oferta-tipo="planMifi"/>

			</div>
		</section>
	</div>
</template>

<script>
	import OffersSlider from '../daniel/offers-slider.vue';
	export default {
		components: {OffersSlider}
	};
</script>